module.exports = __webpack_public_path__ + "img/no-preview.fa414f3e.png";